import React from "react";

export default function index() {
  return (
    <section className="mb-16">
      {/* navbar  */}
      <div className="odoo-nabvar-bg py-6 justify-center flex flex-col sm:flex-row items-center sm:gap-4 text-[#0D1587]">
        <span>Dynamic Solution Innovators Ltd</span>
        <img src="/images/odoo/ellipse.svg" className="hidden sm:block" />
        <span>
          Official <span className="font-bold">Odoo</span> Partner
        </span>
      </div>
      <div className="">
        {/* hero section  */}
        <div className="flex flex-col items-center justify-center max-w-[1136px] mx-auto w-full px-4">
          <img src="/images/odoo/top_section.png" className="hidden sm:block" />
          <img
            src="/images/odoo/top_section_mobile.png"
            className="block sm:hidden"
          />

          <div className="mt-8 sm:-mt-14 flex flex-col gap-4">
            <a href="tel:+8801709647300" className="primary-btn-odoo">
              Call now : <span className="font-normal">+8801709647300</span>
            </a>
            <a
              href="https://wa.me/+8801709647300"
              className="text-white bg-[#25D366] rounded-xl px-4 sm:px-6 py-3 sm:py-4 flex gap-2 items-center text-center justify-center font-bold hover:bg-green-500 transition-all duration-300 ease-in-out"
              target="_blank">
              <img src="/images/odoo/whatsapp_icon_white.svg" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
        {/* second section  */}
        <div className="relative max-w-7xl mx-auto w-full px-4">
          <div className="p-8 sm:p-16 rounded-xl border-[##0000000d] shadow-xl sm:text-2xl mt-8 sm:mt-16 max-w-[1136px] mx-auto w-full border border-[#0000000d]">
            <p>
              Odoo offers a comprehensive suite of open-source business
              applications to meet all your company’s needs—from CRM and
              eCommerce to accounting, inventory, point of sale, and project
              management.{" "}
            </p>
            <p className="mt-8">
              {/* To make this software custom-tailored for you{" "}
              <span className="font-bold">
                {" "}
                - DSi will help you integrate according to your needs.
              </span>{" "} */}
              <span className="font-bold">
                DSi specializes in implementing Odoo{" "}
              </span>{" "}
              to suit your unique requirements, providing seamless integration
              that aligns with your business goals.
            </p>
          </div>
          <div className="hidden xl:block absolute right-0 -bottom-16">
            <img src="/images/odoo/buzz.svg" />
          </div>
        </div>
        {/* third section  */}
        <div className="oval-bg mt-12 sm:mt-24 bg-[#F3F4F5] pb-48 sm:pb-[356px]">
          <div>
            <div className="max-w-[1136px] mx-auto w-full flex flex-col items-center pt-12 px-4">
              <img src="/images/odoo/third_section.svg" />
            </div>
            {/* cards  */}
            <div className="flex justify-center flex-wrap gap-4 mt-16 sm:text-2xl mx-4">
              {/* card 1  */}
              <div className="bg-white rounded-xl flex flex-col items-center gap-4 p-8 max-w-[368px] w-full border">
                <img src="/images/odoo/card_one.svg" />
                <div className="text-center">
                  {" "}
                  Tell <span className="font-bold">DSi </span> <br />
                  your needs
                </div>
              </div>

              {/* card 2  */}
              <div className="bg-white rounded-xl flex flex-col items-center gap-4 p-8 max-w-[368px] w-full border">
                <img src="/images/odoo/card_two.svg" />
                <div className="text-center">
                  {" "}
                  <span className="font-bold">DSi </span>will implement <br />
                  Odoo accordingly
                </div>
              </div>

              {/* card 3  */}
              <div className="bg-white rounded-xl flex flex-col items-center gap-4 p-8 max-w-[368px] w-full border">
                <img src="/images/odoo/card_three.svg" />
                <div className="text-center">
                  {" "}
                  <span className="font-bold">DSi </span>will train & onboard
                  <br />
                  your users
                </div>
              </div>
            </div>
            <div className="max-w-[1136px] mx-auto w-full sm:text-center mt-8 sm:mt-10 sm:text-2xl px-4">
              <span className="font-bold">DSi</span> is a software company with
              over two decades of experience in various sectors. We know that
              every business is unique in it’s own way. We will use our{" "}
              <span className="font-bold">
                {" "}
                coding and industry experience{" "}
              </span>{" "}
              to provide a solution that’s fits your needs and help you in your
              Odoo journey.
            </div>
          </div>
          {/* fourth section  */}
          <div className="max-w-[1136px] mx-auto w-full flex flex-col items-center mt-8 sm:mt-32 px-4">
            <img src="/images/odoo/fourth_section.svg" />
            {/* features  */}
            <div className="mt-8 sm:mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 justify-center sm:gap-16 ">
              <a href="https://www.odoo.com/app/accounting" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/accounting.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Accounting</div>
                </div>
              </a>

              <a href="https://www.odoo.com/app/ecommerce" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/ecommerce.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">e-Commerce</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/sign" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/sign.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Sign</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/crm" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/crm.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">CRM</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/studio" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/studio.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Studio</div>
                </div>
              </a>
              <a
                href="https://www.odoo.com/app/marketing-automation"
                target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/marketing_automation.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Marketing</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/sales" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/sales.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Sales</div>
                </div>
              </a>
              <a
                href="https://www.odoo.com/app/point-of-sale-shop"
                target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/point_of_sale.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Point of Sale</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/expenses" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/expenses.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Expenses</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/invoicing" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/invoices.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Invoices </div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/timesheet" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/hr.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">HR & Timesheet</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/quality" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/quality.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Quality</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/field-service" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/field_service.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Field Service</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/planning" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/planning.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Planning</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/helpdesk" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/help_desk.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Helpdesk </div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/website" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/website.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Website</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/manufacturing" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/manufacturing.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Manufacturing</div>
                </div>
              </a>
              <a
                href="https://www.odoo.com/app/email-marketing"
                target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/email_marketing.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Email Marketing</div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/purchase" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/purchase.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Purchase </div>
                </div>
              </a>
              <a href="https://www.odoo.com/app/inventory" target="_blank">
                <div className="flex flex-col gap-4 items-center">
                  <img
                    src="/images/odoo/services/inventory.png"
                    className="w-32 sm:w-auto border rounded-[36px]"
                  />
                  <div className="font-bold">Inventory</div>
                </div>
              </a>
            </div>
          </div>
        </div>
        {/* fifth section  */}
        <div className="max-w-[1136px] mx-auto w-full flex flex-col items-center mb-8 sm:mb-16 px-4">
          <img src="/images/odoo/group.png" className="-mt-28 sm:-mt-52" />
          <img src="/images/odoo/fifth_section.svg" className="" />
          <div className="text-center sm:text-2xl mt-8">
            Our experts will listen to you <br />
            and make Odoo align with your business
          </div>
          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
            <a href="tel:+8801709647300" className="primary-btn-odoo">
              Call now : <span className="font-normal">+8801709647300</span>
            </a>
            <a
              href="https://wa.me/+8801709647300"
              className="text-white bg-[#25D366] rounded-xl px-4 sm:px-6 py-3 sm:py-4 flex gap-2 items-center text-center justify-center font-bold hover:bg-green-500 transition-all duration-300 ease-in-out"
              target="_blank">
              <img src="/images/odoo/whatsapp_icon_white.svg" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
        {/* sixth section  */}
        <div className="max-w-[1136px] mx-auto w-full mt-24 sm:mt-52 ">
          <img src="/images/odoo/sixth_section.svg" />
          {/* steps  */}
          <div className="flex flex-col gap-6 sm:gap-8">
            {/* step-1  */}
            <div>
              <div className="flex items-center sm:justify-center gap-6 sm:gap-16 mt-8 sm:mt-20 p-4">
                <div className="w-24 sm:w-36">
                  <img src="/images/odoo/roadmap_step_one.svg" />
                </div>
                <div className="flex flex-col gap-2 sm:gap-4">
                  <div className="w-14 sm:w-[72px]">
                    <img src="/images/odoo/step_one.png" />
                  </div>
                  <div className="font-bold text-lg sm:text-3xl">
                    Understand your current workflow
                  </div>
                  <div className="sm:text-xl max-w-2xl hidden sm:block">
                    We meet with your company and understand your business. We
                    understand the current ecosystem and painpoints - so we can
                    make a system that’ll make your life easier.
                  </div>
                </div>
              </div>
              <div className="sm:text-xl max-w-2xl px-4 sm:hidden">
                We meet with your company and understand your business. We
                understand the current ecosystem and painpoints - so we can make
                a system that’ll make your life easier.
              </div>
            </div>

            {/* step-2  */}
            <div>
              <div className="flex items-center sm:justify-center gap-6 sm:gap-16 p-4">
                <div className="w-28 sm:w-36">
                  <img src="/images/odoo/roadmap_step_two.svg" />
                </div>
                <div className="flex flex-col gap-1 sm:gap-4">
                  <div className="w-14 sm:w-[72px]">
                    <img src="/images/odoo/step_two.png" />
                  </div>
                  <div className="font-bold text-lg sm:text-3xl">
                    Implementing Odoo into your business
                  </div>
                  <div className="sm:text-xl max-w-2xl hidden sm:block">
                    We configure Odoo to your unique business needs, ensuring a
                    seamless integration into your operations. Our priority is
                    making the transition to your new system as smooth as
                    possible.
                  </div>
                </div>
              </div>
              <div className="sm:text-xl max-w-2xl sm:hidden px-4">
                We configure Odoo to your unique business needs, ensuring a
                seamless integration into your operations. Our priority is
                making the transition to your new system as smooth as possible.
              </div>
            </div>

            {/* step-3  */}
            <div>
              <div className="flex items-center sm:justify-center gap-6 sm:gap-16 p-4">
                <div className="w-28 sm:w-36">
                  <img src="/images/odoo/roadmap_step_three.svg" />
                </div>
                <div className="flex flex-col gap-2 sm:gap-4">
                  <div className="w-14 sm:w-[72]">
                    <img src="/images/odoo/step_three.png" />
                  </div>
                  <div className="font-bold text-lg sm:text-3xl">
                    Training, onboarding and observation
                  </div>
                  <div className="sm:text-xl max-w-2xl hidden sm:block">
                    We will train and onboard your users onto the new system. In
                    case any issues arise, we will either resolve them with
                    support or address them in the next phase if necessary.
                  </div>
                </div>
              </div>
              <div className="sm:text-xl max-w-2xl sm:hidden px-4">
                We will train and onboard your users onto the new system. In
                case any issues arise, we will either resolve them with support
                or address them in the next phase if necessary.
              </div>
            </div>

            {/* step-4  */}
            <div>
              <div className="flex items-center sm:justify-center gap-6 sm:gap-16 p-4">
                <div className="w-28 sm:w-36">
                  <img src="/images/odoo/roadmap_step_four.svg" />
                </div>
                <div className="flex flex-col gap-2 sm:gap-4">
                  <div className="w-14 sm:w-[72]">
                    <img src="/images/odoo/step_four.png" />
                  </div>
                  <div className="font-bold text-lg sm:text-3xl">
                    Additional customization if needed
                  </div>
                  <div className="sm:text-xl max-w-2xl hidden sm:block">
                    As your users engage with the ERP, new requirements may
                    emerge that are not readily available in Odoo. We’re here to
                    provide seamless customization to your evolving needs.
                  </div>
                </div>
              </div>
              <div className="sm:text-xl max-w-2xl sm:hidden px-4">
                As your users engage with the ERP, new requirements may emerge
                that are not readily available in Odoo. We’re here to provide
                seamless customization to your evolving needs.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
